import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Button } from '@cordata/buffet';
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from 'reactstrap';

const ClickToViewModal = ({ children }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const toggleModal = () =>
    setIsModalOpen(!isModalOpen);

  return (
    <>
      <Button
        color="link"
        type="button"
        className="p-0"
        outline
        onClick={toggleModal}
      >
        Click to view
      </Button>
      <Modal isOpen={isModalOpen} toggle={toggleModal} size="lg">
        <ModalHeader toggle={toggleModal}>Notes</ModalHeader>

        <ModalBody>{children}</ModalBody>

        <ModalFooter>
          <Button type="cancel" color="tertiary" outline onClick={toggleModal}>
            Close
          </Button>
        </ModalFooter>
      </Modal>
    </>
  );
};

ClickToViewModal.propTypes = {
  children: PropTypes.node.isRequired,
};

export default ClickToViewModal;
